import { Provider } from '@angular/core';
import { PinnaklEnvironment } from './environment.model';
import { ENVIRONMENT } from './environment.tokens';

export function providePinnaklEnvironment(environment: PinnaklEnvironment): Provider {
  return {
    provide: ENVIRONMENT,
    useValue: environment,
  };
}
